var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPathSingleTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.388,
    height: 26.999,
    viewBox: "0 0 20.388 26.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M90.112,13.977,70.479,26.826c-.391.314-.57.186-.4-.285l8.077-12.279a2.878,2.878,0,0,0,0-1.706L70.085.457c-.173-.471,0-.6.4-.288L90.108,12.845A.691.691,0,0,1,90.112,13.977Z",
    transform: "translate(-70.016 0.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathSingleTeam);
export default __webpack_public_path__ + "static/media/pathSingleTeam.416ea411a3ae398f7e6a3b03f290b3c0.svg";
export { ForwardRef as ReactComponent };